<template>
  <div class="newsMain">
    <!-- 时空业务中台 -->
    <PcMiddle class="PC"/>
    <MdMiddle class="MD"/>
  </div>
</template>

<script>
// 移动端
import MdMiddle from './MdMiddle.vue'
// pc端
import PcMiddle from './PcMiddle.vue'
export default {
  name: 'newsMain',
  components: {
    PcMiddle,
    MdMiddle
  }
}
</script>

<style lang="scss" scoped>
// 移动
@media only screen and (max-width: 750px) {
  .newsMain{
    .PC{
      display: none;
    }
  }

}
// PC端/
@media only screen and (min-width: 756px) {
  .newsMain{
    .MD{
      display: none;
    }
  }
}
</style>
